import { Component, OnInit, Input, OnChanges, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { CompanyInfo } from 'src/app/models/company-data-model/company-info.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { CompanyCompanyService } from 'src/app/services/company-services/company-company-service/company-company.service';
import { EMPTY, empty, Subscription } from 'rxjs';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { catchError } from 'rxjs/internal/operators/catchError';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-company-info-card',
  templateUrl: './company-info-card.component.html',
  styleUrls: ['./company-info-card.component.scss']
})
export class CompanyInfoCardComponent implements OnInit, OnDestroy, OnChanges {

  @Input() companyInfo: CompanyInfo;
  editingLocked: boolean;
  updateCompanyInfoSubscription: Subscription;
  basicDataForm = new FormGroup({
    city: new FormControl({ value: '', disabled: true }),
    companyCif: new FormControl({ value: '', disabled: true }),
    companyName: new FormControl({ value: '', disabled: true }),
    country: new FormControl({ value: '', disabled: true }),
    email: new FormControl({ value: '', disabled: true }),
    faxNumber: new FormControl({ value: '', disabled: true }),
    fiscalName: new FormControl({ value: '', disabled: true }),
    phoneNumber: new FormControl({ value: '', disabled: true }),
    province: new FormControl({ value: '', disabled: true }),
    region: new FormControl({ value: '', disabled: true }),
    street: new FormControl({ value: '', disabled: true }),
    zipCode: new FormControl({ value: '', disabled: true })
  });

  constructor(private companyService: CompanyCompanyService,
              private snackbarService: SnackBarService,
              private userStorageService: UserStorageService,
              private eRef: ElementRef) {
                this.editingLocked = true;
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.companyInfo) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.companyInfo && !this.editingLocked) {
          this.resetForm();
          this.basicDataForm.get('city').disable();
          this.basicDataForm.get('companyCif').disable();
          this.basicDataForm.get('companyName').disable();
          this.basicDataForm.get('country').disable();
          this.basicDataForm.get('email').disable();
          this.basicDataForm.get('faxNumber').disable();
          this.basicDataForm.get('fiscalName').disable();
          this.basicDataForm.get('phoneNumber').disable();
          this.basicDataForm.get('province').disable();
          this.basicDataForm.get('region').disable();
          this.basicDataForm.get('street').disable();
          this.basicDataForm.get('zipCode').disable();
          this.editingLocked = true;
        }
      }
    }
  }

  private submitForm() {
    this.updateCompanyInfoSubscription = this.companyService.updateCompany(this.companyInfo.InternalId, this.basicDataForm.get('city').value, this.basicDataForm.get('companyCif').value, this.basicDataForm.get('companyName').value, this.basicDataForm.get('country').value, this.basicDataForm.get('email').value, this.basicDataForm.get('faxNumber').value, this.basicDataForm.get('fiscalName').value, this.basicDataForm.get('phoneNumber').value, this.basicDataForm.get('province').value, this.basicDataForm.get('region').value, this.basicDataForm.get('street').value, this.basicDataForm.get('zipCode').value).pipe(
      tap(o => this.snackbarService.open('company-page.snackbar messages.update success', 'success')),
      tap(o => this.lockEdition()),
      tap(o => this.companyService.refreshCompany()),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      const validation = this.validateForm();
      if (validation === true) {
        this.submitForm();
      } else {
        this.snackbarService.open(validation, 'error');
      }
    }
  }

  private validateForm() {
    return true;
  }

  private resetForm() {
    this.basicDataForm.patchValue({
      city: this.companyInfo.City,
      companyCif: this.companyInfo.CompanyCif,
      companyName: this.companyInfo.CompanyName,
      country: this.companyInfo.Country,
      email: this.companyInfo.Email,
      faxNumber: this.companyInfo.FaxNumber,
      fiscalName: this.companyInfo.FiscalName,
      phoneNumber: this.companyInfo.PhoneNumber,
      province: this.companyInfo.Province,
      region: this.companyInfo.Region,
      street: this.companyInfo.Street,
      zipCode: this.companyInfo.ZipCode
    });
  }

  private unlockEdition() {
    this.basicDataForm.get('city').enable();
    this.basicDataForm.get('companyCif').enable();
    this.basicDataForm.get('companyName').enable();
    this.basicDataForm.get('country').enable();
    this.basicDataForm.get('email').enable();
    this.basicDataForm.get('faxNumber').enable();
    this.basicDataForm.get('fiscalName').enable();
    this.basicDataForm.get('phoneNumber').enable();
    this.basicDataForm.get('province').enable();
    this.basicDataForm.get('region').enable();
    this.basicDataForm.get('street').enable();
    this.basicDataForm.get('zipCode').enable();
    this.editingLocked = false;
  }

  private lockEdition() {
    this.basicDataForm.get('city').disable();
    this.basicDataForm.get('companyCif').disable();
    this.basicDataForm.get('companyName').disable();
    this.basicDataForm.get('country').disable();
    this.basicDataForm.get('email').disable();
    this.basicDataForm.get('faxNumber').disable();
    this.basicDataForm.get('fiscalName').disable();
    this.basicDataForm.get('phoneNumber').disable();
    this.basicDataForm.get('province').disable();
    this.basicDataForm.get('region').disable();
    this.basicDataForm.get('street').disable();
    this.basicDataForm.get('zipCode').disable();
    this.editingLocked = true;
  }

  ngOnDestroy() {
    if (this.updateCompanyInfoSubscription) { this.updateCompanyInfoSubscription.unsubscribe(); }
  }
}
